"use client";

import React from "react";
import { ArrowUp, Facebook, Instagram, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="173253" className="flex flex-col gap-3">
        <div className="h-4 w-24 bg-[#1A1A1A] animate-pulse rounded" />
        <div className="h-4 w-32 bg-[#1A1A1A] animate-pulse rounded" />
        <div className="h-4 w-28 bg-[#1A1A1A] animate-pulse rounded" />
        <div className="h-4 w-20 bg-[#1A1A1A] animate-pulse rounded" />
      </div>;
  }
  return <ul className="space-y-3 text-xs">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return <section id="footer" className="bg-[#060606] text-[#F4F4F5] pt-16 pb-8 dark">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          
          {}
          <div className="flex flex-col gap-5">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602928/img/dentconstanta_logo_light.png" alt="The Unshaken Protocol" className="h-7 w-auto object-contain grayscale brightness-200" />
            </Link>
            <p className="text-[#A1A1AA] text-sm leading-relaxed">
              The Unshaken Protocol is the definitive operating system for high-performance traders. We provide the infrastructure for psychological discipline, risk management, and consistent execution in global markets.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-bold text-lg tracking-tighter text-[#F4F4F5]">Protocol Access</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-5">
            <h3 className="font-bold text-lg tracking-tighter text-[#F4F4F5]">Support</h3>
            <ul className="space-y-4 text-xs text-[#A1A1AA]">
              <li>
                <Link to="#" className="flex items-start gap-3 hover:text-[#F4F4F5] transition-colors group">
                  <MapPin className="size-5 shrink-0 text-[#3B82F6] group-hover:text-[#D4AF37] transition-colors" />
                  <span className="leading-tight mt-0.5">Global Protocol Center</span>
                </Link>
              </li>
              <li>
                <Link to="tel:+40123456789" className="flex items-center gap-3 hover:text-[#F4F4F5] transition-colors group">
                  <Phone className="size-5 shrink-0 text-[#3B82F6] group-hover:text-[#D4AF37] transition-colors" />
                  <span>Execution Desk: +40 123 456 789</span>
                </Link>
              </li>
              <li>
                <Link to="mailto:support@unshakenprotocol.com" className="flex items-center gap-3 hover:text-[#F4F4F5] transition-colors group">
                  <Mail className="size-5 shrink-0 text-[#3B82F6] group-hover:text-[#D4AF37] transition-colors" />
                  <span>support@unshakenprotocol.com</span>
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-5 items-start">
            <h3 className="font-bold text-lg tracking-tighter text-[#F4F4F5]">Stay Disciplined</h3>
            <div className="flex gap-3">
              <Link to="#" className="p-2.5 rounded-md bg-[#1A1A1A] hover:bg-[#3B82F6]/20 text-[#F4F4F5] transition-all duration-200 hover:-translate-y-1 border border-[#1A1A1A]" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="#" className="p-2.5 rounded-md bg-[#1A1A1A] hover:bg-[#3B82F6]/20 text-[#F4F4F5] transition-all duration-200 hover:-translate-y-1 border border-[#1A1A1A]" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
            </div>
            
            <div className="mt-auto pt-6 w-full">
              <Button variant="outline" onClick={scrollToTop} className="w-full sm:w-auto border-[#1A1A1A] text-[#F4F4F5] hover:bg-[#F4F4F5] hover:text-[#060606] transition-colors rounded-md font-bold">
                <ArrowUp className="mr-2 size-4" />
                Return to Top
              </Button>
            </div>
          </div>

        </div>

        <Separator className="bg-[#1A1A1A] mb-6" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#A1A1AA]">
          <p>© {new Date().getFullYear()} The Unshaken Protocol. All rights reserved.</p>
          <p className="tracking-wider uppercase font-mono text-[10px]">Discipline &gt; Strategy. Stay Unshaken.</p>
        </div>
      </div>
    </section>;
}